"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SingleDatesWidget_module_scss_1 = __importDefault(require("./SingleDatesWidget.module.scss"));
const react_hook_form_1 = require("react-hook-form");
const react_datepicker_1 = require("react-datepicker");
const nl_1 = __importDefault(require("date-fns/locale/nl"));
const uuid_1 = require("uuid");
require("react-datepicker/dist/react-datepicker.css");
const ti_1 = require("react-icons/ti");
const ri_1 = require("react-icons/ri");
const io_1 = require("react-icons/io");
const react_i18next_1 = require("react-i18next");
const feed_factory_date_widget_1 = __importDefault(require("@feed-factory/feed-factory.date-widget"));
const feed_factory_when_widget_1 = __importDefault(require("@feed-factory/feed-factory.when-widget"));
const generateDefaultEvent = () => {
    return {
        date: null,
        when: [{ timestart: null, timeend: null }],
        id: (0, uuid_1.v4)(),
    };
};
const SingleDatesWidget = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const control = props.formMethods.control; // required, as field array does not like input via props
    const { fields, append, prepend, remove } = (0, react_hook_form_1.useFieldArray)({
        control,
        name: `${props.namespace}`,
        keyName: "id", // default to "id", you can change the key name
    });
    (0, react_datepicker_1.registerLocale)("nl", nl_1.default);
    (0, react_1.useEffect)(() => {
        if (!(fields && fields.length > 0)) {
            append(generateDefaultEvent());
        }
    }, []);
    // console.log(props.formMethods.formState.errors); // DEBUG
    return (react_1.default.createElement("div", { className: SingleDatesWidget_module_scss_1.default.CalendarWidget },
        fields.length > 0 && (react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, t("calendarWidget.date")),
                    react_1.default.createElement("th", null, props.hideWhenStatus
                        ? t("calendarWidget.time")
                        : t("calendarWidget.timeAndStatus")),
                    react_1.default.createElement("th", null,
                        react_1.default.createElement("div", { className: `${SingleDatesWidget_module_scss_1.default.deleteAll} ff-delete-all`, onClick: () => {
                                remove();
                            } },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(ri_1.RiDeleteBin3Line, null),
                                react_1.default.createElement("span", null, t("calendarWidget.deleteAll"))))))),
            react_1.default.createElement("tbody", null, 
            // @ts-ignore // Type SingleDate not allowed as description, but is correct
            fields.map((singleDate, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                // console.log(singleDate); // DEBUG
                return (react_1.default.createElement("tr", { key: singleDate.id },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(feed_factory_date_widget_1.default, { name: `${props.namespace}[${index}].date`, formMethods: props.formMethods, defaultValue: singleDate.date, hasError: (_c = (_b = (_a = props.formMethods.formState.errors.ndtrcEntry) === null || _a === void 0 ? void 0 : _a.calendar) === null || _b === void 0 ? void 0 : _b.singleDates[index]) === null || _c === void 0 ? void 0 : _c.date })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(feed_factory_when_widget_1.default, { defaultValue: (_d = singleDate.when) === null || _d === void 0 ? void 0 : _d[0], formMethods: props.formMethods, namespace: `${props.namespace}[${index}].when[0]`, noStatus: props.hideWhenStatus })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { onClick: () => remove(index), className: SingleDatesWidget_module_scss_1.default.danger },
                            react_1.default.createElement(ti_1.TiDelete, null))),
                    ((_f = (_e = props.formMethods.formState.errors.ndtrcEntry) === null || _e === void 0 ? void 0 : _e.calendar) === null || _f === void 0 ? void 0 : _f.singleDates[index]) && (react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { className: SingleDatesWidget_module_scss_1.default.errorInformation }, [
                            ((_j = (_h = (_g = props.formMethods.formState.errors.ndtrcEntry) === null || _g === void 0 ? void 0 : _g.calendar) === null || _h === void 0 ? void 0 : _h.singleDates[index]) === null || _j === void 0 ? void 0 : _j.date) &&
                                t("calendarWidget.dateRequiredError"),
                            ((_p = (_o = (_m = (_l = (_k = props.formMethods.formState.errors.ndtrcEntry) === null || _k === void 0 ? void 0 : _k.calendar) === null || _l === void 0 ? void 0 : _l.singleDates[index]) === null || _m === void 0 ? void 0 : _m.when) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.timestart) &&
                                t("calendarWidget.timestartRequiredError"),
                        ]
                            .filter((item) => item)
                            .join(" & "))))));
            })))),
        react_1.default.createElement("div", { onClick: () => {
                append(generateDefaultEvent());
            }, className: SingleDatesWidget_module_scss_1.default.add },
            react_1.default.createElement(io_1.IoMdAddCircle, null))));
};
exports.default = SingleDatesWidget;
//# sourceMappingURL=SingleDatesWidget.js.map